import React, { useState } from "react";


export default function FilterLead({ onFilter }) {

  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    mobile: "",
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onFilter) {
      onFilter(filters);

    }
  };

  return (
    <div className="filtercont">
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-lg-10">
            <div className="row">
              <div className="col-12 col-sm-2 pr-lg-0">
                <label>From Date</label>
                <input
                  type="date"
                  name="fromDate"
                  value={filters.fromDate}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="col-12 col-sm-2 pr-lg-0">
                <label>To Date</label>
                <input
                  type="date"
                  name="toDate"
                  value={filters.toDate}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="col-12 col-sm-2 pr-lg-0">
                <label>Mobile</label>
                <input
                  type="number"
                  name="mobile"
                  value={filters.mobile}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="col-12 col-sm-3 pr-lg-0">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={filters.email}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

              <div className="col-12 col-sm-3">
                <label>&nbsp;</label>
                <button
                  type="submit"

                  className="btn btn-default submit sitebtn px-3 text-center"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}
